import * as AC from './actionTypes';

export const openModal = (modalName, props = {}) => ({
  type: AC.OPEN_MODAL,
  name: modalName,
  props,
});

export const closeModal = () => ({
  type: AC.CLOSE_MODAL,
});
